module.exports = __webpack_public_path__ + "img/cat-03-ac.079215c1.svg";